import { BUSINESS_GROUP } from "@helpers/constantes";
import { BusinessGroupDetail } from "@interfaces/response";

export type SiNo = "" | "Sí" | "No";

/** Valores del grupo empresarial en el formulario. */
export interface GrupoEmpresarialValues {
  enGrupoEmpresarial: SiNo;
  numEmpresasGrupo: string;
  esMatrizGrupo: SiNo;
  rfcMatrizGrupo: string;
}

/**
 * Formulario → API: `business_group` es texto en mayúsculas ("SI" | "NO") y el detalle va como JSON; sin grupo
 * el detalle se manda en `null`.
 */
export const toBusinessGroupPayload = (values: GrupoEmpresarialValues) => {
  if (values.enGrupoEmpresarial !== "Sí") {
    return { business_group: BUSINESS_GROUP.no, business_group_detail: null };
  }
  const isParent = values.esMatrizGrupo === "Sí";
  const business_group_detail: BusinessGroupDetail = {
    number_of_companies: Number(values.numEmpresasGrupo),
    is_parent_company: isParent,
    parent_company_rfc: isParent ? null : values.rfcMatrizGrupo.trim(),
  };
  return { business_group: BUSINESS_GROUP.si, business_group_detail };
};

/** API → formulario, para prellenar al regresar a la pantalla. */
export const fromBusinessGroupResponse = (
  businessGroup?: string | null,
  detail?: BusinessGroupDetail | null,
): GrupoEmpresarialValues | null => {
  // Se compara en mayúsculas para aceptar también registros guardados en minúsculas.
  const normalized = businessGroup?.trim().toUpperCase();
  if (normalized === BUSINESS_GROUP.no) {
    return { enGrupoEmpresarial: "No", numEmpresasGrupo: "", esMatrizGrupo: "", rfcMatrizGrupo: "" };
  }
  if (normalized !== BUSINESS_GROUP.si) return null;
  return {
    enGrupoEmpresarial: "Sí",
    numEmpresasGrupo: detail?.number_of_companies ? String(detail.number_of_companies) : "",
    esMatrizGrupo: detail ? (detail.is_parent_company ? "Sí" : "No") : "",
    rfcMatrizGrupo: detail?.parent_company_rfc || "",
  };
};

export interface FormValues {
  company_name: string;
  rfc: string;
  // Grupo empresarial: sin contraparte en Redux/backend todavía.
  enGrupoEmpresarial: SiNo;
  numEmpresasGrupo: string;
  esMatrizGrupo: SiNo;
  rfcMatrizGrupo: string;
  // Uso del crédito (`UsoCredito`)
  reason: string;
  activity: string;
  // Presencia digital (`PresenciaDigital`)
  /** `null` mientras el usuario no contesta: el Sí/No arranca sin opción marcada. */
  has_web_page: boolean | null;
  web_page: string;
  has_social_media: boolean | null;
  linkedin: string;
  facebook: string;
  instagram: string;
  twitter: string;
}
